/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_tip_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Should I tip on the pre-tax or post-tax total?`)
};

const es_pct_tip_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Debo dar la propina sobre el total antes o después de impuestos?`)
};

const de_pct_tip_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollte ich auf den Betrag vor oder nach Steuern Trinkgeld geben?`)
};

const nl_pct_tip_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moet ik fooi geven over het bedrag voor of na belasting?`)
};

const fr_pct_tip_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dois-je calculer le pourboire sur le montant avant ou après taxes ?`)
};

const it_pct_tip_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devo calcolare la mancia sul totale prima o dopo le tasse?`)
};

const pt_br2_pct_tip_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devo dar gorjeta sobre o total antes ou depois dos impostos?`)
};

const pt_pct_tip_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devo dar gorjeta sobre o total antes ou depois de impostos?`)
};

const ja_pct_tip_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`税抜きと税込みのどちらにチップを払うべきですか？`)
};

const zh_pct_tip_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小费应该按税前还是税后总额计算？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_tip_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_tip_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_tip_faq3_q", locale)
	if (locale === "en") return en_pct_tip_faq3_q(inputs)
	if (locale === "es") return es_pct_tip_faq3_q(inputs)
	if (locale === "de") return de_pct_tip_faq3_q(inputs)
	if (locale === "nl") return nl_pct_tip_faq3_q(inputs)
	if (locale === "fr") return fr_pct_tip_faq3_q(inputs)
	if (locale === "it") return it_pct_tip_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_pct_tip_faq3_q(inputs)
	if (locale === "pt") return pt_pct_tip_faq3_q(inputs)
	if (locale === "ja") return ja_pct_tip_faq3_q(inputs)
	return zh_pct_tip_faq3_q(inputs)
};